import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import GuestGuard from 'utils/route-guard/GuestGuard';

// routing
const ExportBarriersPage = Loadable(lazy(() => import('views/exports/barriers')));

// ==============================|| GUEST ROUTING ||============================== //

const MinimalRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/exports',
            element: <ExportBarriersPage />
        }
    ]
};

export default MinimalRoutes;
